import { render, staticRenderFns } from "./JianqiuVsLayout.vue?vue&type=template&id=51a1382a&scoped=true&"
import script from "./JianqiuVsLayout.vue?vue&type=script&lang=js&"
export * from "./JianqiuVsLayout.vue?vue&type=script&lang=js&"
import style0 from "./JianqiuVsLayout.vue?vue&type=style&index=0&id=51a1382a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a1382a",
  null
  
)

export default component.exports